import { BaseSelect } from '@/src/components/Select/Select'
import { BaseButton } from '@/src/components/buttons/BaseButton'
import { useLocationsContext } from '@/src/contexts/LocationsContext'
import { Box, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { WIDGET_IDS, useDashboardEditingStore } from '../../infrastructure/useDashboardEditingStore'

interface ISelectDeviceModalProps {
  isOpen: boolean
  onClose: () => void
}

export const SelectDeviceModal = ({ isOpen, onClose }: ISelectDeviceModalProps) => {
  const { t } = useTranslation()
  const locations = useLocationsContext()
  const devices = locations.getDevices()
  const { tmpLayout } = useDashboardEditingStore()

  const displayedDevicesIds = tmpLayout.filter(item => item.i.split('_')[0] === WIDGET_IDS.LOCATION_AND_DEVICE).map(item => item.deviceId)

  const { addToTmpLayout } = useDashboardEditingStore()

  const options = devices
    // Exclude items with isMainSource set to true
    .filter(item => !item.isMainSource)
    // Exclude displayed devices
    .filter(item => !displayedDevicesIds.some(item2 => item2 === item.id))
    .map((item, idx) => {
      return {
        value: idx,
        label: `${item.name} (${item.locationName})`,
        id: item.id,
      }
    })
  const [selectedDeviceIndex, setSelectedDeviceIndex] = useState(0)

  const onChange = value => {
    setSelectedDeviceIndex(value)
  }

  return (
    <Modal motionPreset='slideInBottom' isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />

      <ModalContent minWidth='624px' minHeight='239px'>
        <ModalHeader>{t('dashboard.select_sub_meter')}</ModalHeader>
        <ModalCloseButton _focus={{}} />

        <ModalBody>
          <Text fontSize='16px' fontWeight={400} lineHeight='24px' color='#656565' padding='8px'>
            {t('dashboard.select_sub_meter_info')}
          </Text>
          <Box>
            <BaseSelect
              label=''
              height='32px'
              fontSize='14px'
              fontWeight={500}
              letterSpacing='0.21px'
              isInvalid={false}
              placeholder={t('dashboard.select_sub_meter')}
              onChange={onChange}
              value={selectedDeviceIndex}
              options={options}
            />
          </Box>
        </ModalBody>

        <ModalFooter>
          <BaseButton
            variant='primary'
            isDisabled={!options[selectedDeviceIndex]}
            onClick={() => {
              const selected = options[selectedDeviceIndex]
              if (!selected) return
              addToTmpLayout(WIDGET_IDS.LOCATION_AND_DEVICE, { deviceId: selected.id })
              onClose()
            }}
          >
            {t('dashboard.insert_widget')}
          </BaseButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
